import React from 'react';

import './CheckboxInput/Styles.scss';

export default function CheckboxInput(props) {
    const {
        formik,
        fieldName,
        label,
        isRequired,
        roundedStyle
    } = props;

    return (
        <div className={roundedStyle ? "field" : "field field-alt"}>
            <label className="checkbox-label">
                <input
                    id={fieldName}
                    name={fieldName}
                    type="checkbox"
                    checked={formik.values[fieldName] || false}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    required={isRequired}
                    className="checkbox-input"
                />
                <span className="checkbox-text">{label}</span>
            </label>

            <span className='field-error'>{formik.touched[fieldName] && formik.errors[fieldName]}</span>
        </div>
    )
}
